import { ProductTypes } from '../../types/product/product';
import { hasNameContaining } from './hasNameContaining';
import { FilterTypes } from '../../store/reducers/productFilter.reducer';
import { isFromCategory } from './isFromCategory';
import { isCheaperThanPrice } from './isCheaperThanPrice';
import { isProductRebond } from './isProductRebond';

export const getFilteredProducts = (
  filterTypes: FilterTypes
): ((products: ProductTypes[]) => ProductTypes[]) => products =>
  products.filter(
    product =>
      (filterTypes.rebond
        ? isProductRebond(filterTypes.rebond)(product)
        : () => true) &&
      hasNameContaining(filterTypes.search)(product) &&
      isCheaperThanPrice(filterTypes.price)(product) &&
      isFromCategory(filterTypes.category)(product)
  );
